<div class="square-revenue-dialog" mat-dialog-content>
    <h2>Square Revenue</h2>
    
    <div class="container">

        <div class="left">
            <div class="square-api-import">
                <button mat-raised-button color="primary" (click)="importFromSquare()" [disabled]="apiBusy">{{apiBusy ? 'Finding Square transfer…' : 'Import from Square API'}}</button>
                <p>Matches production transfers by amount and date, then checks the bank description for a full or truncated reference. Replaces the current list after a successful import.</p>
                <p class="api-error" role="alert" *ngIf="apiError">{{apiError}}</p>
                <p role="status" *ngIf="apiMessage">{{apiMessage}}</p>
                <ng-container *ngIf="apiCandidates.length > 1">
                    <mat-form-field appearance="outline">
                        <mat-label>Matching Square transfer</mat-label>
                        <mat-select [(ngModel)]="selectedPayoutId" [disabled]="apiBusy">
                            <mat-option *ngFor="let candidate of apiCandidates" [value]="candidate.id">{{candidate.arrivalDate | date:'dd MMM yyyy'}} · {{candidate.amount | human}} · {{candidate.reference}} {{candidate.referenceMatch ? '(' + candidate.referenceMatch + ' reference)' : ''}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-button (click)="importFromSquare(selectedPayoutId)" [disabled]="apiBusy || !selectedPayoutId">Import selected transfer</button>
                </ng-container>
            </div>
            <ngx-dropzone (change)="submitProof($event)" [disabled]="apiBusy">
                <ngx-dropzone-label>Upload Evidence</ngx-dropzone-label>
            </ngx-dropzone>
        </div>

        <div class="right">
            <h2>Deposited: {{deposited | human}}</h2>

            <div class="transfers">
                <div class="transfer" *ngFor="let transfer of transaction.squareTransactions">
                    <mat-form-field class="description" appearance="outline" subscriptSizing="dynamic">
                        <input matInput maxlength="24" [ngModel]="truncateTransferNote(transfer.note)" (ngModelChange)="updateTransferNote(transfer, $event)">
                    </mat-form-field>
                    <ap-money class="amount" [outline]="true" [(amount)]="transfer.totalCollected"></ap-money>
                </div>

                <div class="transfer totalReconilled">
                    <div class="label">Total:</div>
                    <div class="amount">{{totalReconilled | human}}</div>
                </div>
            </div>

            <!-- <div>Total Fees: {{feesTotal | human}}</div> -->
        </div>
    </div>
</div>

<div class="actions" mat-dialog-actions>
    <button (click)="save()" mat-raised-button [disabled]="apiBusy">Save</button>
    <button (click)="clear()" mat-raised-button [disabled]="apiBusy">Clear</button>
    <button (click)="commit()" class="commit" mat-raised-button [disabled]="apiBusy">Commit</button>
</div>
